import { render, staticRenderFns } from "./ContexualApproval.vue?vue&type=template&id=81f91928&scoped=true"
import script from "./ContexualApproval.vue?vue&type=script&lang=js"
export * from "./ContexualApproval.vue?vue&type=script&lang=js"
import style0 from "./ContexualApproval.vue?vue&type=style&index=0&id=81f91928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f91928",
  null
  
)

export default component.exports